import { GridColDef, GridRenderCellParams, GridRenderEditCellParams } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import i18nStore from "../../../../i18n/store";
import { NodeInterface } from "../../../tables/schemas/nodes";
import filterStore from "../filters/filtersStore";
import { ParamType } from "../../enums";


const useMuiCalculationsBranchesColDefs = (
    projectNodes: NodeInterface[],
): GridColDef[] => {
    const translations = i18nStore.getTranslations;
    const [colDefs, setColDefs] = useState<GridColDef[]>([]);

    useEffect(() => {
        let newColDefs: GridColDef[] = [
            {
                field: "name",
                headerName: translations.name,
                headerAlign: 'center',
                type: "string",
            },
            {
                field: "start_node_pk_x",
                headerName: translations._tablesBranchesEquip.startNode,
                headerAlign: 'center',
                type: "string",
                renderCell: (params: GridRenderCellParams) => {
                    const node = projectNodes.find((node: any) => node.id == params.value);
                    return (
                        <span>{node?.name}</span>
                    );
                },
            },
            {
                field: "end_node_pk",
                type: "string",
                headerName: translations._tablesBranchesEquip.endNode,
                headerAlign: 'center',
                renderCell: (params: GridRenderCellParams) => {
                    const node = projectNodes.find((node: any) => node.id == params.value);
                    return (
                        <span>{node?.name}</span>
                    );
                },
            },
        ];

        if (filterStore.getBranchValueTypes.find(vt => vt === ParamType.Current.name)) {
            newColDefs.push(
                {
                    field: "Ia",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>a</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Ib",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>b</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Ic",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>c</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_a",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>a</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_b",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>b</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_c",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>c</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "I1",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>1</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "I2",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>2</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "I0",
                    type: 'number',
                    renderHeader: () => (<span>I<sub>0</sub>, {translations._measUnit.kA}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_1",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>1</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_2",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>2</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_0",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>0</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
            );
        }

        if (filterStore.getBranchValueTypes.find(vt => vt === ParamType.Power.name)) {
            newColDefs.push(
                {
                    field: "P1",
                    type: 'number',
                    renderHeader: () => (<span>P<sub>1</sub>, {translations._measUnit.MW}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "P2",
                    type: 'number',
                    renderHeader: () => (<span>P<sub>2</sub>, {translations._measUnit.MW}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "P0",
                    type: 'number',
                    renderHeader: () => (<span>P<sub>0</sub>, {translations._measUnit.MW}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Q1",
                    type: 'number',
                    renderHeader: () => (<span>Q<sub>1</sub>, {translations._measUnit.Mvar}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Q2",
                    type: 'number',
                    renderHeader: () => (<span>Q<sub>2</sub>, {translations._measUnit.Mvar}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Q0",
                    type: 'number',
                    renderHeader: () => (<span>Q<sub>0</sub>, {translations._measUnit.Mvar}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Pa",
                    type: 'number',
                    renderHeader: () => (<span>P<sub>a</sub>, {translations._measUnit.MW}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Pb",
                    type: 'number',
                    renderHeader: () => (<span>P<sub>b</sub>, {translations._measUnit.MW}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Pc",
                    type: 'number',
                    renderHeader: () => (<span>P<sub>c</sub>, {translations._measUnit.MW}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Qa",
                    type: 'number',
                    renderHeader: () => (<span>Q<sub>a</sub>, {translations._measUnit.Mvar}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Qb",
                    type: 'number',
                    renderHeader: () => (<span>Q<sub>b</sub>, {translations._measUnit.Mvar}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Qc",
                    type: 'number',
                    renderHeader: () => (<span>Q<sub>c</sub>, {translations._measUnit.Mvar}</span>),
                    headerAlign: 'center',
                },
            );
        }
        if (filterStore.getBranchValueTypes.find(vt => vt === ParamType.Resistance.name)) {
            newColDefs.push(
                {
                    field: "R1",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>1</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "R2",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>2</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "R0",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>0</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "X1",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>1</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "X2",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>2</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "X0",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>0</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },

                {
                    field: "Ra",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>a</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Rb",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>b</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Rc",
                    type: 'number',
                    renderHeader: () => (<span>R<sub>c</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Xa",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>a</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Xb",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>b</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Xc",
                    type: 'number',
                    renderHeader: () => (<span>X<sub>c</sub>, {translations._measUnit.Om}</span>),
                    headerAlign: 'center',
                },
            );
        }

        setColDefs(newColDefs);
    }, [i18nStore.getCurrentLanguageCode, filterStore.getBranchValueTypes, projectNodes]);

    return colDefs;
}


export default useMuiCalculationsBranchesColDefs;
